var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, Schema, type, defaultValue } from "./decorators/type.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let CollisionsSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "collisions");
    __publicField(this, "collisionMap");
  }
};
__decorateClass([
  type("object")
], CollisionsSchema.prototype, "collisions", 2);
__decorateClass([
  type("object"),
  defaultValue({})
], CollisionsSchema.prototype, "collisionMap", 2);
CollisionsSchema = __decorateClass([
  Component("Collisions")
], CollisionsSchema);
let CollisionFiltersSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "filters");
  }
};
__decorateClass([
  type(["number"]),
  defaultValue([])
], CollisionFiltersSchema.prototype, "filters", 2);
CollisionFiltersSchema = __decorateClass([
  Component("CollisionFilters")
], CollisionFiltersSchema);
const __vite_glob_0_19 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get CollisionFiltersSchema() {
    return CollisionFiltersSchema;
  },
  get CollisionsSchema() {
    return CollisionsSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  CollisionsSchema as C,
  __vite_glob_0_19 as _,
  CollisionFiltersSchema as a
};
//# sourceMappingURL=Collisions-9e9492fb.js.map
